import React from 'react';

import config from '../../config';
import { Wrapper, Background, SVG } from './Plot.style'
import * as scales from '../../utils';

import mapPNG from '../../assets/BackPlate.jpg'

function Plot({ size, children }) {
  // TODO: Tidy / move to util
  const imgRatio = config.plot.height / config.plot.width;
  const divRatio = size.height / size.width;
  const isTooNarrow = imgRatio < divRatio;
  let svgSize = { ...size };
  let margin = 0;
  if (imgRatio !== divRatio) {
    if (isTooNarrow) svgSize = {
      width: size.width,
      height: size.width * imgRatio,
    }
    else {
      svgSize = {
        height: size.height,
        width: size.height / imgRatio,
      };
      margin = (size.width - (size.height / imgRatio)) / 2;
    }
  }
  
  const xScale = scales.xScale.range([0, svgSize.width])
  const yScale = scales.yScale.range([svgSize.height, 0])
  return (
    <Wrapper margin={margin}>
      <Background src={mapPNG} />
      <SVG margin={margin} {...svgSize}>
        {children({ xScale, yScale, actualSize: svgSize })}
      </SVG>
    </Wrapper>
  );
}

export default Plot;



// WEBPACK FOOTER //
// ./src/components/Plot/Plot.component.js